import React from 'react';
const NAV_LINKS = [{
  label: 'Menu',
  href: '#menu'
}, {
  label: 'Gallery',
  href: '#gallery'
}];
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-md border-b border-white/10" data-id="element-136">
      <div className="flex items-center justify-between px-4 py-3 md:px-8 md:py-4 max-w-7xl mx-auto w-full" data-id="element-137">
        {/* Brand mark — left */}
        <a href="#hero" className="focus:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-full overflow-hidden shrink-0" data-id="element-138">
          <img src="https://cdn.magicpatterns.com/uploads/qn5huQ1wbWqQRdRPuiL3Zk/fe16f767-5450-41fb-aa51-b725aac133de.jpg" alt="Sips & Nibbles Logo" className="h-12 w-12 md:h-16 md:w-16 object-cover shadow-lg shadow-black/50" data-id="element-139" />
        </a>

        {/* Pill navigation — right */}
        <nav aria-label="Primary" data-id="element-140">
          <div className="flex items-center rounded-full border border-white/10 bg-black/40 p-1 md:p-1.5 shadow-inner" data-id="element-141">
            {NAV_LINKS.map(link => <a key={link.label} href={link.href} className="rounded-full px-3 py-2 md:px-5 md:py-2.5 text-white/80 hover:text-accent text-[10px] md:text-xs uppercase tracking-[0.15em] md:tracking-[0.2em] font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-142">
                {link.label}
              </a>)}
            <a href="#book" className="rounded-full bg-accent px-4 py-2 md:px-6 md:py-2.5 text-black text-[10px] md:text-xs uppercase tracking-[0.15em] md:tracking-[0.2em] font-bold transition-colors hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white ml-1 md:ml-0" data-id="element-143">
              Contact
            </a>
          </div>
        </nav>
      </div>
    </header>;
}